import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import styled, {css} from 'styled-components'

export const StyledDisabilityExperienceProcessingContainer = styled(Flexbox)(
    () => css`
        & label {
            min-width: 110px;
        }
    `
)
